import { MapPin, Landmark, ArrowRight } from "lucide-react"
import { Button } from "../../components/ui/button"
import { Helmet } from "react-helmet-async"
import Campus1 from "../../assets/CampusImages/campus1.JPG"
import Campus2 from "../../assets/CampusImages/campus2.png"
import IMG_0781 from "../../assets/CampusImages/IMG_0781.jpg"
import IMG_0786 from "../../assets/CampusImages/IMG_0786.jpg"
import IMG_0794 from "../../assets/CampusImages/IMG_0794.jpg"
import IMG_0801 from "../../assets/CampusImages/IMG_0801.jpg"
import IMG_0805 from "../../assets/CampusImages/IMG_0805.jpg"
import IMG_0807 from "../../assets/CampusImages/IMG_0807.jpg"
import IMG_0824 from "../../assets/CampusImages/IMG_0824.jpg"
import IMG_0828 from "../../assets/CampusImages/IMG_0828.jpg"
import IMG_0834 from "../../assets/CampusImages/IMG_0834.jpg"
import IMG_4210 from "../../assets/CampusImages/IMG_4210.jpg"
import IMG_4220 from "../../assets/CampusImages/IMG_4220.jpg"
import IMG_8324 from "../../assets/CampusImages/IMG_8324.jpg"
import IMG_8325 from "../../assets/CampusImages/IMG_8325.jpg"
import IMG_8329 from "../../assets/CampusImages/IMG_8329.jpg"

const CAMPUS_GALLERY_IMAGES = [
    IMG_0781, IMG_0786, IMG_0794, IMG_0801, IMG_0805, IMG_0807,
    IMG_0824, IMG_0828, IMG_0834, IMG_4210, IMG_4220, IMG_8324, IMG_8325, IMG_8329,
]

export default function Campus() {
    const stats = [
        { val: "2", label: "Campus Principaux" },
        { val: "1000+", label: "Étudiants" },
        { val: "BURUNDI", label: "Localisation" },
        { val: "EXCELLENCE", label: "Vision" }
    ]

    const campusData = [
        {
            name: "Campus Ngozi",
            title: "Le Cœur Historique",
            location: "Quartier Kanyami, Ngozi",
            description: "Le siège social de l'Université de Ngozi, niché dans un cadre serein favorisant la réflexion et l'apprentissage académique.",
            features: ["Administration Centrale", "Bibliothèque Centrale", "Amphithéâtre", "Espaces de Co-working"],
            image: Campus1,
            imageBehind: Campus2,
            color: "from-primary/20 to-primary/5"
        },
        {
            name: "Campus Bujumbura",
            title: "Le Pôle Économique",
            location: "Kamenge, Bujumbura",
            description: "Une extension stratégique au cœur de la capitale économique pour rapprocher les formations de l'écosystème professionnel.",
            features: ["Faculté de Droit, Sciences Économiques et Gestion", "Faculté de Médecine et Sciences de la Santé", "ISCOBA", "Laboratoires de Medecine et Sciences de la Santé", "Laboratoires d'Informatique", "Services aux Etudiants", "Eapaces innovateurs"],
            image: Campus2,
            imageBehind: Campus2,
            color: "from-accent/20 to-accent/5"
        }
    ]

    return (
        <div className="min-h-screen bg-background font-sans text-foreground">
            <Helmet>
                <title>Nos Campus - Université de Ngozi</title>
                <meta name="description" content="Découvrez les campus de l'Université de Ngozi à Ngozi et Bujumbura. Des infrastructures modernes pour une éducation d'excellence." />
            </Helmet>

            {/* Hero Section - Standard (ref: DroitEcoGestion) */}
            <header className="relative min-h-[60vh] flex items-center bg-primary overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/80 to-transparent" />
                </div>
                <div className="container relative z-10 py-20">
                    <div className="max-w-3xl">
                        <div className="inline-flex items-center gap-4 mb-8 translate-y-4 animate-in fade-in duration-700 fill-mode-forwards">
                            <span className="text-[10px] uppercase tracking-[0.3em] text-accent font-black">Notre Empreinte</span>
                            <div className="h-px w-12 bg-accent/50" />
                            <span className="text-[10px] text-primary-foreground/60 uppercase tracking-widest font-bold">Infrastructures d'Excellence</span>
                        </div>
                        <h1 className="heading-1 mb-8 leading-[0.95] font-serif tracking-tight text-white translate-y-4 animate-in fade-in duration-1000 fill-mode-forwards delay-200">
                            <span className="block italic font-light text-accent/90">Un Environnement</span>
                            <span className="block text-white mt-2">Propice au Savoir</span>
                        </h1>
                        <div className="border-l-4 border-accent pl-8 mb-12 max-w-2xl translate-y-4 animate-in fade-in duration-1000 fill-mode-forwards delay-500">
                            <p className="text-lg md:text-xl font-light leading-relaxed text-primary-foreground/90">
                                L'Université de Ngozi s'étend sur deux sites stratégiques, alliant tradition académique et modernité urbaine.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-20">
                    <div className="w-px h-12 bg-white" />
                </div>
            </header>

            {/* Dateline Bar */}
            <div className="border-y border-border bg-secondary/5">
                <div className="container py-6 flex flex-wrap items-center gap-12 lg:gap-20">
                    {stats.map((stat, i) => (
                        <div key={i} className="flex items-center gap-3 group">
                            <span className="text-2xl font-black text-primary group-hover:text-accent transition-colors">{stat.val}</span>
                            <span className="text-[10px] text-muted-foreground uppercase font-black tracking-[0.2em]">{stat.label}</span>
                            {i < stats.length - 1 && <span className="hidden lg:block h-4 w-px bg-border ml-4" />}
                        </div>
                    ))}
                </div>
            </div>

            {/* Main Campus Section */}
            <article className="container py-20 lg:py-32">
                <div className="grid lg:grid-cols-[300px_1fr] gap-20">
                    {/* Floating Navigation */}
                    <aside className="lg:sticky lg:top-32 lg:self-start hidden lg:block">
                        <nav className="space-y-2 mb-12">
                            <p className="text-[10px] uppercase tracking-[0.3em] font-black text-muted-foreground mb-6 pb-2 border-b-2 border-primary/10">
                                Présentation
                            </p>
                            {campusData.map((campus, i) => (
                                <a
                                    key={i}
                                    href={`#${campus.name.toLowerCase().replace(/\s+/g, '-')}`}
                                    className="group flex items-center justify-between w-full py-3 text-xs font-black text-muted-foreground hover:text-primary transition-all border-r-2 border-transparent hover:border-primary pr-4"
                                >
                                    <div className="flex items-center gap-3">
                                        <span className="text-[10px] font-serif italic text-accent opacity-0 group-hover:opacity-100 transition-opacity">0{i + 1}</span>
                                        <span className="uppercase tracking-widest">{campus.name}</span>
                                    </div>
                                    <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-all" />
                                </a>
                            ))}
                        </nav>

                        <div className="bg-primary p-8 rounded-3xl text-primary-foreground relative overflow-hidden shadow-2xl">
                            <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-full -mr-12 -mt-12" />
                            <h4 className="text-[10px] uppercase tracking-[0.2em] font-black mb-6 text-accent">Services Campus</h4>
                            <ul className="space-y-4 text-[11px] font-medium border-t border-white/10 pt-4">
                                <li className="flex items-center gap-3">
                                    <div className="w-1.5 h-1.5 bg-accent rounded-full" />
                                    Accès WiFi Fibre
                                </li>
                                <li className="flex items-center gap-3">
                                    <div className="w-1.5 h-1.5 bg-accent rounded-full" />
                                    Laboratoires Equipés
                                </li>
                                <li className="flex items-center gap-3">
                                    <div className="w-1.5 h-1.5 bg-accent rounded-full" />
                                    Espaces de Détente
                                </li>
                            </ul>
                        </div>
                    </aside>

                    {/* Campus Detailed Display */}
                    <main className="space-y-32">
                        {campusData.map((campus, idx) => (
                            <section
                                key={idx}
                                id={campus.name.toLowerCase().replace(/\s+/g, '-')}
                                className="group relative scroll-mt-32"
                            >
                                <div className="grid lg:grid-cols-2 gap-12 items-center">
                                    <div className={`order-2 ${idx % 2 === 0 ? "lg:order-1" : "lg:order-2"} space-y-8`}>
                                        <div className="space-y-4">
                                            <div className="flex items-center gap-3 text-accent transition-all animate-in slide-in-from-left duration-700">
                                                <div className="w-12 h-1 bg-accent rounded-full" />
                                                <span className="text-[10px] font-black uppercase tracking-[0.2em]">{campus.name}</span>
                                            </div>
                                            <h2 className="text-4xl lg:text-5xl font-serif font-black italic text-foreground tracking-tight leading-none">
                                                {campus.title}
                                            </h2>
                                        </div>

                                        <p className="text-lg text-muted-foreground leading-relaxed font-light">
                                            {campus.description}
                                        </p>

                                        <div className="flex items-center gap-3 text-sm font-bold text-primary">
                                            <MapPin className="w-5 h-5 text-accent" />
                                            {campus.location}
                                        </div>

                                        <div className="grid grid-cols-2 gap-4 pt-4">
                                            {campus.features.map((feature, i) => (
                                                <div key={i} className="flex items-center gap-3 p-4 bg-secondary/5 rounded-2xl border border-border group-hover:border-accent/30 transition-colors">
                                                    <div className="w-2 h-2 bg-accent rounded-full" />
                                                    <span className="text-[10px] font-black uppercase tracking-widest text-muted-foreground">{feature}</span>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="pt-8">
                                            <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-white px-8 py-6 rounded-xl text-xs font-black uppercase tracking-widest transition-all">
                                                Explorer ce Campus
                                                <ArrowRight className="w-4 h-4 ml-2" />
                                            </Button>
                                        </div>
                                    </div>

                                    {/* Visual Card — stacked photo layers with clear depth */}
                                    <figure
                                        className={`order-1 ${idx % 2 === 0 ? "lg:order-2" : "lg:order-1"} relative pt-8 pl-8 sm:pt-10 sm:pl-10 min-h-[320px] sm:min-h-[380px]`}
                                        aria-labelledby={`campus-image-${idx}`}
                                    >
                                        {/* Back layer — different image per campus, recedes visually */}
                                        <div
                                            className="absolute bottom-2 left-0 right-8 top-2 sm:bottom-3 sm:right-10 sm:top-3 rounded-2xl sm:rounded-3xl overflow-hidden -rotate-6 motion-reduce:rotate-0 border border-border/50 bg-muted/30 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.15),0_12px_32px_-8px_rgba(0,0,0,0.2)]"
                                            aria-hidden="true"
                                        >
                                            <img src={campus.imageBehind} alt="" className="w-full h-full object-cover opacity-80" role="presentation" />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" aria-hidden="true" />
                                        </div>
                                        {/* Middle layer — soft echo of main image */}
                                        <div
                                            className="absolute bottom-5 left-4 right-4 top-5 sm:bottom-6 sm:left-5 sm:right-5 sm:top-6 rounded-2xl sm:rounded-[1.5rem] overflow-hidden rotate-3 motion-reduce:rotate-0 border border-border/60 bg-background shadow-[0_8px_28px_-4px_rgba(0,0,0,0.12),0_20px_44px_-10px_rgba(0,0,0,0.18)]"
                                            aria-hidden="true"
                                        >
                                            <img src={campus.image} alt="" className="w-full h-full object-cover opacity-90" role="presentation" />
                                            <div className="absolute inset-0 bg-white/5 pointer-events-none" aria-hidden="true" />
                                        </div>
                                        {/* Main photo — hero card with lift on hover */}
                                        <div
                                            className={`relative aspect-[4/5] min-h-[280px] bg-gradient-to-br ${campus.color} rounded-[1.75rem] sm:rounded-[2rem] overflow-hidden border border-border/80 shadow-[0_16px_40px_-8px_rgba(0,0,0,0.2),0_0_0_1px_rgba(0,0,0,0.06)] transition-all duration-500 ease-out group-hover:-translate-y-2 group-hover:shadow-[0_24px_56px_-12px_rgba(0,0,0,0.25),0_0_0_1px_rgba(0,0,0,0.08)] motion-reduce:transition-none motion-reduce:group-hover:translate-y-0`}
                                        >
                                            <img
                                                src={campus.image}
                                                alt={`Vue du ${campus.name}, ${campus.location}. ${campus.title}.`}
                                                className="absolute inset-0 w-full h-full object-cover"
                                                loading="lazy"
                                                id={`campus-image-${idx}`}
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/15 via-transparent to-transparent pointer-events-none" aria-hidden="true" />
                                            {/* Info label */}
                                            <div
                                                className="absolute bottom-6 right-6 sm:bottom-10 sm:right-10 bg-white/95 backdrop-blur-sm px-5 py-2.5 sm:px-6 sm:py-3 rounded-xl shadow-lg flex items-center gap-3 border border-border/80"
                                                role="group"
                                                aria-label="Infrastructures : Moderne et ouvert"
                                            >
                                                <div className="w-8 h-8 sm:w-9 sm:h-9 bg-accent rounded-lg flex items-center justify-center text-white flex-shrink-0" aria-hidden="true">
                                                    <Landmark className="w-4 h-4" />
                                                </div>
                                                <div className="text-left min-w-0">
                                                    <p className="text-[10px] font-black uppercase tracking-widest text-muted-foreground leading-none">Infrastructures</p>
                                                    <p className="text-sm font-bold text-primary leading-tight">Moderne & Ouvert</p>
                                                </div>
                                            </div>
                                        </div>
                                    </figure>
                                </div>
                            </section>
                        ))}
                    </main>
                </div>
            </article>

            {/* Campus gallery — other images from CampusImages */}
            <section className="border-t border-border bg-secondary/5 py-20">
                <div className="container">
                    <div className="flex items-center gap-3 mb-10">
                        <div className="w-12 h-1 bg-accent rounded-full" />
                        <span className="text-[10px] font-black uppercase tracking-[0.3em] text-primary">En images</span>
                    </div>
                    <h2 className="text-3xl lg:text-4xl font-serif font-bold text-foreground mb-4">Vues du campus</h2>
                    <p className="text-muted-foreground max-w-2xl mb-12">
                        Infrastructures, espaces de vie et cadres d&apos;apprentissage sur nos sites de Ngozi et Bujumbura.
                    </p>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                        {CAMPUS_GALLERY_IMAGES.map((src, i) => (
                            <div
                                key={i}
                                className="aspect-[4/3] rounded-2xl overflow-hidden border border-border bg-muted group hover:border-accent/50 transition-colors"
                            >
                                <img
                                    src={src}
                                    alt=""
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Immersive CTA Footer */}
            <footer className="bg-primary text-white border-t-8 border-accent relative overflow-hidden">
                <div className="absolute top-0 right-0 w-1/3 h-full bg-accent/5 -skew-x-12 origin-top-right pointer-events-none" />
                <div className="container py-24 text-center relative z-10">
                    <div className="max-w-2xl mx-auto space-y-10">
                        <div className="inline-flex items-center gap-6 mb-4">
                            <div className="h-px w-8 bg-accent" />
                            <span className="text-[11px] uppercase tracking-[0.4em] text-accent font-black">Planifiez votre visite</span>
                            <div className="h-px w-8 bg-accent" />
                        </div>

                        <h2 className="text-4xl lg:text-6xl font-serif italic mb-8 leading-tight">
                            Venez vivre l'expérience <br /> <span className="text-accent underline decoration-accent/30 decoration-8 underline-offset-4">UNG par vous-même</span>.
                        </h2>

                        {/* <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                            <Button className="bg-accent text-accent-foreground px-12 py-8 text-sm font-black hover:bg-white hover:text-primary hover:-translate-y-2 transition-all duration-500 rounded-2xl transform shadow-2xl">
                                Demander une Visite Guidée
                                <ArrowRight className="w-5 h-5 ml-3" />
                            </Button>
                            <Button variant="ghost" className="text-white border-2 border-white/20 hover:bg-white/5 px-12 py-8 text-sm font-black rounded-2xl transition-all">
                                Nous Contacter
                            </Button>
                        </div> */}

                        <p className="text-white/40 text-[10px] uppercase tracking-[0.2em] font-medium mt-12">
                            © 2024 Université de Ngozi · Gestion des Campus
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    )
}
